import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {
  constructor(
    public router: Router
    , private cookieService: CookieService) { this.getTemplate(router.url); }
  template: string;

  ngOnInit() {
  }
  backToLogin() {
     this.router.navigate(['/']);
    this.cookieService.deleteAll('/');
  }
  getTemplate(url: string) {
    switch (url) {
      case '/email_verified':
        this.template = 'Your Email Address is Verified, click below to login';
        break;
      case '/email_already_verified':
        this.template = 'Your Email Address is Already Verified, click below to login';
        break;
      case '/post-register':
        this.template = 'Your Business registration is successful, click below to login';
        break;
        case '/register-successful':
          this.template = 'Your Profile setup is successful, Please login to do your identity verification.';
          break;        
      default:
        break;
    }
  }
}
